import WbSunnyRoundedIcon from '@mui/icons-material/WbSunnyRounded'
import WbCloudyRoundedIcon from '@mui/icons-material/WbCloudyRounded'
import ThunderstormRoundedIcon from '@mui/icons-material/ThunderstormRounded'
import { VersionReportStatus } from '../../../../../domain/entity/version-report/VersionReportVersionEntity'
import { colorPalette } from '../../../../style/colorPalette'

type ReportStatusIconProps = {
  status: VersionReportStatus
  size?: number
}
export const ReportStatusIcon = ({
  status,
  size = 28,
}: ReportStatusIconProps) => {
  const fontSize = `${size}px`
  switch (status) {
    case 'SUNNY':
      return (
        <WbSunnyRoundedIcon sx={{ fontSize, color: colorPalette.yellow[3] }} />
      )
    case 'CLOUDY':
      return (
        <WbCloudyRoundedIcon
          sx={{ fontSize, color: colorPalette.monotone[3] }}
        />
      )
    case 'RAINY':
      return (
        <ThunderstormRoundedIcon
          sx={{ fontSize, color: colorPalette.blue[8] }}
        />
      )
  }
}
